function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.304177 21.0643C0.709748 20.6587 1.36731 20.6587 1.77288 21.0643L3.80816 23.0996L5.84344 21.0643C6.24901 20.6587 6.90657 20.6587 7.31214 21.0643C7.71771 21.4699 7.71771 22.1274 7.31214 22.533L4.54251 25.3026C4.13694 25.7082 3.47938 25.7082 3.07381 25.3026L0.304178 22.533C-0.101392 22.1274 -0.101393 21.4699 0.304177 21.0643Z",
  fill: "#0055FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.81026 15.2201C4.38382 15.2201 4.84878 15.6851 4.84878 16.2586V24.5668C4.84878 25.1404 4.38382 25.6054 3.81026 25.6054C3.23669 25.6054 2.77173 25.1404 2.77173 24.5668V16.2586C2.77173 15.6851 3.23669 15.2201 3.81026 15.2201Z",
  fill: "#0055FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6916 2.22239C10.4631 1.22625 4.60632 5.46732 3.60957 11.6958C3.51894 12.2621 2.98634 12.6478 2.41998 12.5571C1.85363 12.4665 1.46798 11.9339 1.55861 11.3676C2.73663 4.00641 9.65854 -1.00588 17.0196 0.171403L17.0197 0.171419C24.3809 1.34943 29.3932 8.27135 28.2159 15.6324L28.2159 15.6325C27.0379 22.9936 20.1161 28.0058 12.7552 26.8287C11.6991 26.6602 10.6677 26.3663 9.68179 25.9536C9.1527 25.7322 8.90331 25.1238 9.12476 24.5947C9.34621 24.0656 9.95465 23.8162 10.4837 24.0376C11.3177 24.3867 12.1898 24.6352 13.0826 24.7777L13.0829 24.7777C19.3113 25.7738 25.1681 21.5328 26.1649 15.3044C27.161 9.07593 22.9201 3.21914 16.6916 2.22239Z",
  fill: "#0055FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0181 8.42696V6.73474",
  stroke: "#0055FF",
  strokeWidth: 1.24623,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0181 18.5796V20.2718",
  stroke: "#0055FF",
  strokeWidth: 1.24623,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.082 17.372C12.5167 18.1144 13.3103 18.573 14.1704 18.5803H16.0321C17.3401 18.6136 18.4275 17.58 18.4601 16.272C18.4887 15.14 17.7123 14.1464 16.607 13.8998L13.4359 13.1029C12.1618 12.8044 11.3715 11.5296 11.6699 10.2555C11.9232 9.17541 12.8916 8.41571 14.0016 8.427H15.8633C16.724 8.43299 17.5183 8.89226 17.953 9.63535",
  stroke: "#0055FF",
  strokeWidth: 1.24623,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLoggiDropoff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = React.forwardRef(SvgLoggiDropoff);
export default __webpack_public_path__ + "static/media/loggi-dropoff.46af1e05.svg";
export { ForwardRef as ReactComponent };